export default __webpack_public_path__ + "static/media/aboutDeepak.77f45ff6.jpeg";